import React from "react";
import { Upload, Spin, App } from "antd";
import { RxAvatar } from "react-icons/rx";
//
import { base64Image } from "../util/image";
// component
// redux
import placeholder from "asset/img/placeholder/img_placeholder.png";
import { uploadPhotoTest } from "store/user/user/user.action";

const UploadAvatar = (props) => {
  // -------------------------- VAR --------------------------
  const { message } = App?.useApp();
  const label = props?.label || "Avatar";
  const loading = props?.loading || false;
  const disabled = props?.disabled || loading;
  const image = props?.image || "";
  const width = props?.width || 400;
  const height = props?.height || 400;
  const icon = props?.icon || <RxAvatar size={40} color="#aeaeae" />;

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  const beforeUpload = (file) => {
    const isJpgOrPng =
      file.type === "image/jpeg" || "image/jpg" || "image/webp";

    if (!isJpgOrPng) {
      message.error("You can only upload JPG, JPEG, WEBP file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const handleUpload = async (action) => {
    const file = action.file;
    console.log({ action });
    if (!file) {
      return message.error("File có vấn đề, vui lòng thử lại file khác");
    }
    // uploadPhotoTest({ file });
    base64Image(file, width, height)
      .then((preview) => {
        console.log({ preview });
        props.onChange(preview);
      })
      .catch((err) => {
        console.log({ err });

        message.error(err?.message || "Có lỗi xảy ra, xin vui lòng thử lại");
      });
  };

  const onChange = ({ files }) => {
    console.log({ files });
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------

  const renderFeature = () => {
    console.log({ image });
    return (
      <img
        src={image}
        alt="Avatar"
        className="h-full w-full rounded-md object-cover"
        onError={(e) => {
          e.target.src = placeholder;
          e.target.style.backgroundColor = "#fff";
        }}
      />
    );
  };

  const renderButton = () => {
    return (
      <div
        className="flex flex-col items-center justify-center"
        style={{ position: "relative" }}
      >
        {icon}
        <div style={{ marginTop: 8, fontSize: 18, color: "#999" }}>{label}</div>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Upload
      showUploadList={false}
      disabled={disabled}
      onChange={onChange}
      customRequest={handleUpload}
      beforeUpload={beforeUpload}
      maxCount={1}
      multiple={false}
      accept=".jpeg,.webp,.jpg"
    >
      <div
        className="align-center flex justify-center"
        style={{
          width: 200,
          height: 200,
          background: "#f1f1f1",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 10,
          border: "2.5px dashed rgba(0,0,0,0.2)",
          padding: 4,
          overflow: "hidden",
          cursor: "pointer",
        }}
      >
        {loading ? <Spin /> : image ? renderFeature() : renderButton()}
      </div>
    </Upload>
  );
};

export default UploadAvatar;
